import { render, staticRenderFns } from "./DialogFormat.vue?vue&type=template&id=0008134e"
import script from "./DialogFormat.vue?vue&type=script&lang=js"
export * from "./DialogFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports